/* eslint-disable react/prop-types */
/* eslint-disable no-undef */
import { Form, Input, Button, Checkbox, Col, Row, Divider, Alert, Modal, message, Radio, DatePicker, Select, notification } from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import colors from 'constants/colors';
import React, { useEffect } from 'react';
import { login } from '../../actions';
import { classOptions, genderOptions } from '../UserProfile/components/UpdateProfile/data';
import { queryFirst } from 'helpers/QueryHelper';
import { generateSHA1 } from 'helpers/CryptoHelper';
import moment from 'moment';
import { sendEmailV2 } from 'helpers/MailHelper';
import { checkExistsEmail } from 'modules/Administration/components/Users/api/user_api';

const backgroundImage = require('assets/img/home/Books_laptop.png').default;

const getPopupContainer = (trigger) => {
  return trigger.parentElement;
};

export default ({ countOpen, onBackLogin }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const [modalStudentVisible, setModalStudentVisible] = React.useState(false);
  const [isProcessing, setIsProcessing] = React.useState(false);

  const onCloseModal = () => {
    setModalStudentVisible(false);
  };

  const onOpenLoginModal = () => {
    onCloseModal();
    onBackLogin();
  };

  const handleSendMail = ({ email, password }) => {
    return new Promise((resolve, reject) => {
      sendEmailV2(email, password, 'SACHSO_Mail_RegisterUser')
        .then((response) => {
          resolve({
            mailStatus: 1,
            mailMessage: 'Thành công',
          });
        })
        .catch((err) => {
          reject({
            mailStatus: 0,
            mailMessage: 'Thất bại',
          });
        });
    });
  };

  const onFinish = async (values) => {
    try {
      setIsProcessing(true);
      const { fullName, sex, birthday, phone, classId, email, password } = values;

      await checkExistsEmail(email)
        .then(() => {
          notification.error({
            message: 'Email đã được đăng ký',
            description: 'Vui lòng chọn email khác!',
            duration: 10,
          });
        })
        .catch(async () => {
          const schoolTypeId = classId >= 10 ? 3 : classId >= 6 ? 2 : classId >= 1 ? 1 : 0;

          const userInfor = await queryFirst('p_SACHSO_Users_Register', {
            Email: email,
            Password: generateSHA1(password),
            FullName: fullName,
            Phone: phone ?? '',
            SchoolTypeId: schoolTypeId,
            ClassId: classId,
            // CityId: 0,
            Sex: sex,
            Status: 'ACTIVE',
            Birthday: moment(birthday).format('YYYY-MM-DD HH:mm:ss'),
            RoleId: 1,
          });
          if (userInfor?.id) {
            notification.success({
              message: 'Đăng ký thành công',
              duration: 10,
            });
            dispatch(login(email, password));
            handleSendMail({ email, password });
          } else {
            notification.error({
              message: 'Đăng ký thất bại',
              description: 'Vui lòng thử lại sau!',
              duration: 10,
            });
          }
        });
    } catch (error) {
      notification.error({
        message: 'Có lỗi xảy ra!',
        description: 'Vui lòng thử lại sau!',
        duration: 10,
      });
    } finally {
      setIsProcessing(false);
    }
  };

  useEffect(() => {
    if (countOpen) {
      setModalStudentVisible(true);
    } else {
      setModalStudentVisible(false);
    }
  }, [countOpen]);

  return (
    <Modal
      title={<span style={{ fontSize: 24, fontWeight: 600, color: colors.font }}>ĐĂNG KÝ HỌC SINH</span>}
      visible={modalStudentVisible}
      centered
      closeIcon={
        <CloseCircleOutlined
          style={{ fontSize: 24, color: '#017AFF', cursor: 'pointer' }}
          onClick={() => {
            onCloseModal();
          }}
        />
      }
      onCancel={onCloseModal}
      footer={null}
      width={800}
    >
      <Form layout='vertical' autoComplete='off' form={form} onFinish={onFinish} requiredMark={false} style={{ fontWeight: 600 }}>
        <Row gutter={[16, 0]}>
          <Col sm={16} xs={24}>
            <Form.Item label='Họ và tên' name='fullName' hasFeedback rules={[{ whitespace: true, required: true, message: 'Chưa nhập họ và tên' }]}>
              <Input allowClear size='large' />
            </Form.Item>
          </Col>
          <Col sm={8} xs={24}>
            <Form.Item label='Giới tính' name='sex' hasFeedback rules={[{ required: true, message: 'Chưa nhập' }]}>
              <Radio.Group options={genderOptions} />
            </Form.Item>
          </Col>

          <Col md={12} xs={24}>
            <Form.Item name='birthday' label='Ngày sinh'>
              <DatePicker format='DD/MM/YYYY' style={{ width: '100%' }} size='large' getPopupContainer={getPopupContainer} />
            </Form.Item>
          </Col>
          <Col md={12} xs={24}>
            <Form.Item
              label='Số điện thoại'
              name='phone'
              hasFeedback
              rules={[
                {
                  pattern: /^(\+84|0)(\d{8,12})$/,
                  message: 'Số điện thoại không hợp lệ',
                },
              ]}
            >
              <Input allowClear size='large' />
            </Form.Item>
          </Col>
          <Col md={12} xs={24}>
            <Form.Item name='classId' label='Lớp học' rules={[{ required: true, message: 'Chưa nhập Lớp học' }]}>
              <Select placeholder='Chọn lớp' options={classOptions} size='large' getPopupContainer={getPopupContainer} />
            </Form.Item>
          </Col>
          <Col md={12} xs={24}>
            <Form.Item
              label='Email (dùng để đăng nhập)'
              name='email'
              hasFeedback
              rules={[
                { type: 'email', message: 'Email không hợp lệ' },
                { whitespace: true, required: true, message: 'Chưa nhập Email' },
              ]}
            >
              <Input allowClear size='large' />
            </Form.Item>
          </Col>
          <Col md={12} xs={24}>
            <Form.Item
              label='Mật khẩu'
              name='password'
              hasFeedback
              rules={[
                { whitespace: true, required: true, message: 'Chưa nhập mật khẩu' },
                { min: 6, message: 'Mật khẩu ít nhất có 6 ký tự' },
              ]}
            >
              <Input.Password allowClear size='large' />
            </Form.Item>
          </Col>
          <Col md={12} xs={24}>
            <Form.Item
              label='Xác nhận lại mật khẩu'
              name='confirmPassword'
              dependencies={['password']}
              hasFeedback
              rules={[
                { whitespace: true, required: true, message: 'Chưa nhập xác nhận mật khẩu' },
                ({ getFieldValue }) => ({
                  validator(rule, value) {
                    if (!value || getFieldValue('password') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('Xác nhận mật khẩu không khớp'));
                  },
                }),
              ]}
            >
              <Input.Password allowClear size='large' />
            </Form.Item>
          </Col>
          <Col md={12} xs={24}></Col>
        </Row>

        <Button loading={isProcessing} size='large' className='mt-3 mb-2' htmlType='submit' type='primary' block style={{ backgroundColor: '#017AFF', fontWeight: 600, height: 48, borderRadius: '0.25rem' }}>
          ĐĂNG KÝ
        </Button>
        <div style={{ textAlign: 'center' }}>
          <span style={{ color: colors.greyChateau }}>Bạn đã có tải khoản?</span>
          <Button type='link' size='small' onClick={onOpenLoginModal}>
            Đăng nhập
          </Button>
        </div>
      </Form>
    </Modal>
  );
};
